/**
 * warranty-cart.js — cart-side enforcement for HME Care warranty lines.
 *
 * The warranty is a fixed-price band variant added alongside its product with a
 * hidden `_parent_id` (the parent variant id) and `_warranty` flag. This script
 * keeps the cart honest on every cart change:
 *   - removes a warranty line whose parent product is no longer in the cart
 *     (so cover can't be bought on its own, or left behind after removing a product);
 *   - forces each warranty line to quantity 1.
 * It works off /cart.js (server truth), not the DOM, so it can't be bypassed by
 * editing the page. (The qty control is also hidden via CSS as a courtesy.)
 */
(function () {
  var busy = false;

  function changeUrl() {
    return (window.theme && theme.routes && theme.routes.cart_change_url) || '/cart/change.js';
  }

  function isWarranty(item) {
    var p = item.properties || {};
    return p._warranty === '1' || p._warranty === 1;
  }

  function apply(changes, i) {
    if (i >= changes.length) {
      busy = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }
    fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: changes[i].id, quantity: changes[i].quantity }),
    })
      .then(function () { apply(changes, i + 1); })
      .catch(function () { busy = false; });
  }

  function enforce() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var present = {};
        items.forEach(function (it) { present[String(it.variant_id)] = true; });

        var changes = [];
        items.forEach(function (it) {
          if (!isWarranty(it)) return;
          var parent = (it.properties || {})._parent_id;
          var orphan = parent && !present[String(parent)];
          if (orphan) changes.push({ id: it.key, quantity: 0 });
          else if (it.quantity !== 1) changes.push({ id: it.key, quantity: 1 });
        });

        if (!changes.length) { busy = false; return; }
        apply(changes, 0);
      })
      .catch(function () { busy = false; });
  }

  var trigger = function () { setTimeout(enforce, 60); };
  document.addEventListener('cart:item-added', trigger);
  document.addEventListener('line-item:change:end', trigger);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
})();
